<!-- src/components/ControlButtons.vue -->

<template>
  <div class="button-container">
    <!-- Кнопки для смены формы -->
    <button @click="setShape('sphere')">Сфера</button>
    <button @click="setShape('random')">Случайно</button>
    <button @click="setShape('line')">Линия</button>

    <!-- Кнопки для смены периода -->
    <button @click="setPeriod('Proto-Renaissance')">Проторенессанс</button>
    <button @click="setPeriod('Early Renaissance')">Ранний Ренессанс</button>
    <button @click="setPeriod('High Renaissance')">Высокий Ренессанс</button>
    <button @click="setPeriod('Late Renaissance')">Поздний Ренессанс</button>
    <button @click="setPeriod('All')">Все</button>
    <!-- Новая кнопка -->
  </div>
</template>

<script setup>
const emit = defineEmits(["update-shape", "update-period"]);

// Функция для смены формы
const setShape = (shape) => {
  emit("update-shape", shape);
};

// Функция для смены периода
const setPeriod = (period) => {
  emit("update-period", period);
};
</script>

<style scoped>
.button-container {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

button {
  padding: 10px 20px;
  background: #333;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

button:hover {
  background: #555;
}
</style>
